import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map';
import { Organization } from '../Classes/OrganizationClass';
import { FeatureClass } from '../Classes/FeatureConfigurationClass';
import { Observable } from 'rxjs/Observable';



@Injectable()
export class OrganizationService {
  getHeadersForMultipart(): any {
    throw new Error("Method not implemented.");
  }
  constructor(private http: Http) { }

  Get_OrgDetails(mQuery: string, mQuerysecond: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let OrgDetails = { "mQuery": JSON.stringify(mQuery), "mQuerysecond": JSON.stringify(mQuerysecond) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: OrgDetails });
    return this.http.get('api/Organization/Get_OrgDetails', options)
      .map((res: Response) => res.json());
  }

  GetState() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Organization/GetstateDetails', options)
      .map((res: Response) => res.json());
  }
  GetPMSMaster() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Organization/GetPMSDetails', options)
      .map((res: Response) => res.json());
  }

  GetPMSType() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Organization/GetPMSType', options)
      .map((res: Response) => res.json());
  }

  GetEditOrgDetails(TenantId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let TenantID = { "TenantId": JSON.stringify(TenantId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: TenantID });
    return this.http.get('api/Organization/GetEditOrgDetails', options)
      .map((res: Response) => res.json());
  }

  GetOrgchangeLog(TenantId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let body = { "TenantId": JSON.stringify(TenantId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: body });
    return this.http.get('api/Organization/GetOrgchangeLog', options)
      .map((res: Response) => res.json());
  }

  SaveOrganizationDetails(_Organization: Organization) {
    let body: string = JSON.stringify(_Organization);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Organization/SaveOrganizationDetails', body, options)
      .map((res: Response) => res.json());
  }

  /*************************Feature Configuration********************************/

  GetInvoiceEntryNotification(TenantId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let TenantID = { "TenantId": JSON.stringify(TenantId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: TenantID });
    return this.http.get('api/Organization/GetInvoiceEntryNotification', options)
      .map((res: Response) => res.json());
  }

  SaveFeatureConfigDetails(_FeatureConfig: FeatureClass) {
    let body: string = JSON.stringify(_FeatureConfig);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/Organization/SaveFeatureConfigDetails', body, options)
      .map((res: Response) => res.json());
  }
  GetAllFeatureConfig(TenantId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let TenantID = { "TenantId": JSON.stringify(TenantId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: TenantID });
    return this.http.get('api/Organization/GetAllFeatureConfig', options)
      .map((res: Response) => res.json());
  }

  GetAllMasterdata() {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/Organization/GetAllMasterdata', options)
      .map((res: Response) => res.json());
  }

  GetAllSubModuleMaster(TenantId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let TenantID = { "TenantId": JSON.stringify(TenantId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: TenantID });
    return this.http.get('api/Organization/GetAllSubModuleMaster', options)
      .map((res: Response) => res.json());
  }

  GetAllModuleMaster(TenantId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let TenantID = { "TenantId": JSON.stringify(TenantId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: TenantID });
    return this.http.get('api/Organization/GetAllModuleMaster', options)
      .map((res: Response) => res.json());
  }
  /************************* End Feature Configuration********************************/

  GetEntitiesExportTemplate() {
    //let headers: Headers = new Headers({ 'Content-Type': 'application/json' });

    let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this.http.get('api/Organization/GetEntitiesExportTemplate', options)
      .map(res => res.blob())

  }


  GetSubscriptionExportTemplate(TenantId: string) {
    
    //let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let TenantID = { "TenantId": JSON.stringify(TenantId) };
    let options = new RequestOptions({ responseType: ResponseContentType.Blob, params: TenantID });
    return this.http.get('api/Organization/GetSubscriptionExportTemplate', options)
      .map(res => res.blob())

  }
  GetDefaultTimeZone(TenantId: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let TenantID = { "TenantId": JSON.stringify(TenantId) };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: TenantID });
    return this.http.get('api/Organization/GetEnterprizeTimeZone', options).map((res: Response) => res.json());
  }
  VerifyTimeSelected(TenantId: string, selHour: number) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let body = { "TenantId": JSON.stringify(TenantId), "selHour": selHour };
    let options: RequestOptions = new RequestOptions({ headers: headers, params: body });
    return this.http.get('api/Organization/VerifyTimeForZone', options).map((res: Response) => res.json());
  }
  
}



// WEBPACK FOOTER //
// ./src/app/Services/OrganizationService.ts